<template>
  <div class="mt-8">
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" />
    </div>
    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <MainJournalTable
        :loading="isLoading"
        :rows="mainJournal"
        :columns="columns"
        :line-numbers="true"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { MAIN_JOURNAL_REQUEST } from '@/store/actions/journal';
import dataListMixin from '@/mixins/dataListMixin';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import PageHeader from '@/components/ui/PageHeader';
import MainJournalTable from '@/components/generalJournal/MainJournalTable';

export default {
  mixins: [dataListMixin, validationMixin],

  validations() {
    return {
      form: {
        loanId: {
          required,
        },
        status: {
          required,
        },
      },
    };
  },

  data() {
    return {
      storeActionListRequest: MAIN_JOURNAL_REQUEST,
      columns: [
        {
          label: this.$t('table.date'),
          field: 'transactionDate',
          filterable: true,
        },
        {
          label: this.$t('table.transactionDescription'),
          field: 'description',
        },
        {
          label: 'Active',
          field: 'activeAccount',
          filterable: true,
        },
        {
          label: 'Passive',
          field: 'passiveAccount',
          filterable: true,
        },
        {
          label: this.$t('table.amount'),
          field: 'amount',
          filterable: true,
        },
      ],
      transactionIdToUpdate: null,
      modalId: 'customer-transaction-update',
      form: {
        loanId: '',
        status: null,
      },
    };
  },

  computed: {
    ...mapGetters([
      'mainJournal',
      'mainJournalMeta',
      'mainJournalStatus',
      'customerTransactionUpdateStatus',
    ]),
    isLoading() {
      return this.mainJournalStatus === 'loading';
    },
    isUpdating() {
      return false;
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    setPaginationValues() {
      this.totalRecords = this.mainJournalMeta ? this.mainJournalMeta.total : 1;
      this.page = this.mainJournalMeta.currentPage;
      this.totalPage = this.mainJournalMeta.lastPage;
    },
  },

  components: {
    PageHeader,
    MainJournalTable,
  },
};
</script>
